"use strict";
exports.__esModule = true;
exports.AVATAR_SHAPE = exports.AVATAR_SIZES = void 0;
exports.AVATAR_SIZES = {
    xxs: 'h-6 w-6',
    xs: 'h-8 w-8',
    sm: 'h-10 w-10',
    base: 'h-12 w-12',
    lg: 'h-14 w-14',
    xl: 'h-16 w-16'
};
exports.AVATAR_SHAPE = {
    full: 'rounded-full',
    huge: 'rounded-3xl',
    large: 'rounded-2xl',
    medium: 'rounded-lg',
    small: 'rounded',
    tiny: 'rounded-sm',
    none: 'rounded-none'
};
//# sourceMappingURL=avatar.style.js.map